// extracted by mini-css-extract-plugin
export var aspectRatioBox = "MyEvents-module--aspect-ratio-box--9f6ae";
export var buttonDiv = "MyEvents-module--button-div--10c74";
export var loaderSvg = "MyEvents-module--loader-svg--c58c8";
export var myeventsAllEventsBtnDesktop = "MyEvents-module--myevents-all-events-btn-desktop--79626";
export var myeventsAllEventsBtnMobile = "MyEvents-module--myevents-all-events-btn-mobile--d1f7e";
export var myeventsColumnContainer = "MyEvents-module--myevents-column-container--b022e";
export var myeventsContentContainer = "MyEvents-module--myevents-content-container--0b625";
export var myeventsEventName = "MyEvents-module--myevents-event-name--5435e";
export var myeventsHeaderImage = "MyEvents-module--myevents-header-image--7fb71";
export var myeventsHeaderImageContainer = "MyEvents-module--myevents-header-image-container--d450e";
export var myeventsOuterContainer = "MyEvents-module--myevents-outer-container--1a59a";
export var myeventsPrimaryWrapper = "MyEvents-module--myevents-primary-wrapper--63b99";
export var myeventsTitle = "MyEvents-module--myevents-title--01840";
export var myeventsTitleWrapper = "MyEvents-module--myevents-title-wrapper--e4a71";
export var myeventsViewEventBtn = "MyEvents-module--myevents-view-event-btn--149c0";
export var noEventsBottomContainer = "MyEvents-module--no-events-bottom-container--518e3";
export var noEventsFindMyEventsColumnWrapper = "MyEvents-module--no-events-find-my-events-column-wrapper--432d9";
export var noEventsManageMyEventsBtn = "MyEvents-module--no-events-manage-my-events-btn--5a5a8";
export var noEventsTopContainer = "MyEvents-module--no-events-top-container--4fa1f";
export var spin = "MyEvents-module--spin--1e868";